import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-consulta-recall",
  templateUrl: "./consulta-recall.component.html",
  styleUrls: ["./consulta-recall.component.scss"],
})
export class ConsultaRecallComponent implements OnInit {
  @Input() consulta: any;
  @Input() titulo = "";
  @Input() idConsulta = "";
  @Input() tipoConsulta = "";
  @Input() codigoControle = "";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = "warning";
  listaConsulta: any;

  @Input() token = "";

  constructor() {}

  ngOnInit() {
    this.getInformativo(this.consulta);
  }

  ngOnChanges() {
    this.titulo = "Histórico de Chamado para Recall";
  }

  getInformativo(params) {
    this.listaConsulta = params.lista;

    if (this.listaConsulta.length > 0) {
      this.consulta.lista = this.listaConsulta;
    } else {
      this.statusMsg = "SEM DETALHAMENTO";
      this.status = "success";
    }
  }
}
